/**
 * 营运中心--》到货确认
 */

export default {
  hide_print_all_radio: ['92886'], // 202506102117216531474, 屏蔽掉打印清单时的“全部”选项
  hide_print_end_site: ['92886'], // 202507101854031506532, 屏蔽掉按到站打印按钮
  show_more_landing_fee_input_custom_check: ['81338','82622'], // 在途清单，到货清单，落地费中'81338', '82622'单独定制 仅费用3时输入或聚焦时再相加七个费用 后续定制企业可不走此逻辑 先保留，后续可废弃
  // tips：分担配载新增中第二步更多卸货费及校验也使用此开关 https://imagecdn.ymm56.com/ymmfile/static/resource/0894a069-1720-4fab-8f2b-248dcfa78811.png
  // tips:配载清单中运输合同 更多卸货费及校验也使用此开关 https://imagecdn.ymm56.com/ymmfile/static/resource/89292662-c357-4a68-8a5a-b20e8395f03f.png
  show_more_landing_fee_input: ['81338','82622','87702','88533','93255'], // 202507011556129203132 在途清单，到货清单，落地费中从公版3个改成7个，并校验7个费用并累加七个费用 主定制逻辑 https://imagecdn.ymm56.com/ymmfile/static/resource/4f8e5021-81a7-4d52-ac9a-7a70e9b008e0.png
  // 批量到货确认 202602071718484976384转定制
  batch_arrival_confirm: ['82635', '83214'],
}
